<template>
  <b-row>
    <input class="modal-btn" type="checkbox" id="modal-btn" name="modal-btn" />
    <label for="modal-btn" @click="showModal = true"
      ><Create /> Agregar Nuevo Usuario <i class="uil uil-expand-arrows"></i
    ></label>
    <b-modal
      v-model="showModal"
      @hideModal="closeModal"
      hide-footer
      hide-header
    >
      <CreateUsers
        :profileOptions="sendProfileOptions"
        :listServices="listServices"
        :showModal="showModal"
        :closeModal="closeModal"
        :getUsers="getUsers"
        :ministerList="ministerList"
        :relacionUS="relacionUS"
      />
    </b-modal>
  </b-row>
</template>

<script>
import CreateUsers from "./CreateUsers.vue";
import Create from "../../../../components/icons/user/Create.vue";
import axios from "axios";
import { mapState } from "vuex";
import { possibleRoles } from "../../../../components/tools/utils";
export default {
  components: {
    CreateUsers,
    Create,
  },
  data() {
    return {
      showModal: false,
      listServices: null,
      profileOptions: [
        { value: null, text: "- Seleccionar Perfil -" },
        { value: 5, text: "Funcionario" },
        { value: 4, text: "Encargado BGI" },
        { value: 3, text: "Jefe de Servicio" },
        { value: 6, text: "Representante Ministerial" },
        { value: 2, text: "Administrador de la DIPRES" },
      ],
      sendProfileOptions: [],
    };
  },
  props: ["relacionUS", "getUsers", "ministerList"],
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    profileListSuperAdmin: function() {
      this.sendProfileOptions = this.profileOptions;
    },
    profileList: function() {
      this.sendProfileOptions = this.profileOptions.filter((p) =>
        possibleRoles(this.relacionUS.rolId).includes(p.value)
      );
      this.sendProfileOptions.unshift({
        value: null,
        text: "- Selecciona una opción -",
      });
    },
    formatServices: function(lista) {
      let toReturn = lista.map((i) => ({
        value: i.id,
        text: i.nombre,
      }));
      toReturn.unshift({
        value: null,
        text: "- Selecciona una opción -",
      });

      return toReturn;
    },
    serviceListSuperAdmin: async function() {
      const res = await axios.get(
        `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/`,
        {
          headers: {
            Authorization: `JWT ${localStorage.getItem("userToken")}`,
          },
        }
      );
      console.log(res.data);
      this.listServices = this.formatServices(res.data);
    },
    servicesList: async function() {
      try {
        if (this.relacionUS.rolId === 1) {
          const res = await axios.get(
            `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/`,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );

          this.listServices = this.formatServices(res.data);
        } else if (this.relacionUS.rolId === 6) {
          const res = await axios.get(
            `${process.env.VUE_APP_RUTA_API}/instituciones/ministerios/${this.relacionUS.ministerio.id}`
          );
          this.listServices = this.formatServices(res.data.servicios);
        } else if (this.relacionUS.rolId === 4 || this.relacionUS.rolId === 3 || this.relacionUS.rolId === 2) {
          this.listServices = this.formatServices(this.usuario.servicios.filter(s => s.rolId !== 5));
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeModal: function() {
      this.showModal = false;
    },
  },
  watch: {
    relacionUS: function() {
      if (!this.relacionUS) return;
      this.servicesList();
      this.profileList();
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.usuario.username === process.env.VUE_APP_USER_ADMIN) {
        this.serviceListSuperAdmin();
        this.profileListSuperAdmin();
      } else {
        this.servicesList();
        this.profileList();
      }
    }, 200);
  },
};
</script>

<style scoped>
.row {
  margin: 0;
  text-align: end;
  position: relative;
}
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300;400;600&display=swap");

*,
*::before,
*::after {
  box-sizing: border-box;
}

p {
  font-family: "Fira Sans", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.7;
  color: #1f2029;
}

[type="checkbox"]:checked,
[type="checkbox"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.modal-btn:checked + label,
.modal-btn:not(:checked) + label {
  position: relative;
  font-family: "Fira Sans", sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 2;
  height: 50px;
  transition: all 200ms linear;
  width: 260px;
  letter-spacing: 1px;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  text-align: center;
  -ms-flex-item-align: center;
  align-self: center;
  border: none;
  cursor: pointer;
  background-color: #052333;
  color: #fff;
}

.modal-btn:checked + label .uil,
.modal-btn:not(:checked) + label .uil {
  margin-left: 10px;
  font-size: 18px;
}
.modal {
  position: fixed;
  display: block;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0 auto;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  overflow-x: hidden;
  background-color: rgba(31, 32, 41, 0.75);
  pointer-events: none;
  opacity: 0;
  transition: opacity 250ms 700ms ease;
}
.modal-btn:checked ~ .modal {
  pointer-events: auto;
  opacity: 1;
  transition: all 300ms ease-in-out;
}
.modal-wrap {
  position: relative;
  display: block;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  overflow: hidden;
  padding-bottom: 20px;
  background-color: #fff;
  -ms-flex-item-align: center;
  align-self: center;
  box-shadow: 0 12px 25px 0 rgba(199, 175, 189, 0.25);
  opacity: 0;
  transform: scale(0.6);
  transition: opacity 250ms 250ms ease, transform 300ms 250ms ease;
}
.modal-wrap img {
  display: block;
  width: 100%;
  height: auto;
}
.modal-wrap p {
  padding: 20px 30px 0 30px;
}
.modal-btn:checked ~ .modal .modal-wrap {
  opacity: 1;
  transform: scale(1);
  transition: opacity 250ms 500ms ease, transform 350ms 500ms ease;
}

.logo {
  position: absolute;
  top: 25px;
  left: 25px;
  display: block;
  z-index: 1000;
  transition: all 250ms linear;
}
.logo img {
  height: 26px;
  width: auto;
  display: block;
  filter: brightness(10%);
  transition: filter 250ms 700ms linear;
}
.modal-btn:checked ~ .logo img {
  filter: brightness(100%);
  transition: all 250ms linear;
}

@media screen and (max-width: 770px) {
  .modal-btn:checked + label,
  .modal-btn:not(:checked) + label {
    width: 200px;
    font-size: 12px;
  }
}

@media screen and (max-width: 516px) {
  .modal-btn:checked + label,
  .modal-btn:not(:checked) + label {
    position: relative;
    top: 30px;
  }
}

@media screen and (max-width: 500px) {
  .modal-wrap {
    width: calc(100% - 40px);
    padding-bottom: 15px;
  }
  .modal-wrap p {
    padding: 15px 20px 0 20px;
  }
}
</style>
